import { render, staticRenderFns } from "./protectionMap.vue?vue&type=template&id=61910c97&"
import script from "./protectionMap.vue?vue&type=script&lang=js&"
export * from "./protectionMap.vue?vue&type=script&lang=js&"
import style0 from "./protectionMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports